import { StyleSheet } from 'react-native';

import { THEME, LAYOUT } from 'reactor/common';

const { COLOR, UNIT } = THEME;

const HEIGHT = UNIT * 4.4;

export default StyleSheet.create({
  container: {
    height: HEIGHT,
    justifyContent: 'space-between',
  },

  column: {
    flex: 1,
    justifyContent: 'center',
    height: HEIGHT,
  },

  content: {
    paddingHorizontal: UNIT,
  },

  even: {
    backgroundColor: COLOR.DISABLED,
  },

  heading: {
    backgroundColor: COLOR.BACKGROUND,
  },

  icon: {
    alignItems: 'center',
  },

  input: {
    backgroundColor: COLOR.TRANSPARENT,
    borderWidth: 0,
    color: COLOR.TEXT,
    flex: 1,
    height: HEIGHT,
    fontSize: UNIT * 1.4,
  },

  row: LAYOUT.STYLE.ROW,
});
